import React from 'react' // eslint-disable-line
import styled from 'styled-components'
import { Config } from '../../../../config'

export const ProductRating = ({
  maxRating = 5,
  fillColor = Config.palette.yellow,
  emptyColor = Config.palette.disabled,
  value = 0,
  onClick,
  listingPage,
  smallMargin,
  productId,
  idPrefix,
}: any) => {
  const onChange = (inputValue: any) => {
    onClick(inputValue)
  }

  const renderRating = () => {
    const ratingNodes = []

    for (let i = maxRating; i > 0; i--) {
      const id = `${idPrefix}-${productId}_${value}_${i}`
      const starNodeInput = (
        <Radio
          key={`input_${id}`}
          type="radio"
          id={id}
          value={i}
          checked={value === i}
          onChange={() => onChange(i)}
        />
      )
      const starNodeLabel = (
        <Rating
          key={`label_${id}`}
          full={value >= i}
          htmlFor={id}
          fillColor={fillColor}
          emptyColor={emptyColor}
        >
          {renderIcon(i, value)}
        </Rating>
      )

      ratingNodes.push(starNodeInput)
      ratingNodes.push(starNodeLabel)
    }

    return ratingNodes.length ? ratingNodes : null
  }

  const renderIcon = (index: number, value: string) => {
    return <Icon key={`icon_${index + value}`}>&#9733;</Icon>
  }

  return (
    <Container listingPage={listingPage}>
      <RatingContainer smallMargin={smallMargin}>
        {renderRating()}
      </RatingContainer>
    </Container>
  )
}

type ContainerProps = {
  listingPage?: boolean
}
const Container = styled.div<ContainerProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  padding-top: ${(props) => (props.listingPage ? '0.8rem' : '0')};
  align-items: center;
  align-self: center;
`

type RatingContainerProps = {
  smallMargin?: boolean
}

const RatingContainer = styled.div<RatingContainerProps>`
  display: flex;
  flex-direction: row-reverse;
  margin-bottom: ${(props) => (props.smallMargin ? '0.2rem' : '1.2rem')};
`

const Icon = styled.i`
  font-style: normal;
  font-size: 1.7rem;
`

const Radio = styled.input`
  display: none;
  position: absolute;
  margin-left: -9999; // TODO: Review this line
`

type RatingProps = {
  full?: boolean
  fillColor?: string
  emptyColor?: string
}

const Rating = styled.label<RatingProps>`
  cursor: pointer;
  color: ${(props) => (props.full ? props.fillColor : props.emptyColor)};
`
